import { Button, CircularProgress, Grid, Stack, styled, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { PRIMARY_LIGHT_BLUE, WHITE } from "../../colors";

import InquiryTypeService from "../../services/inquiryTypeService";

const CustomTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  backgroundColor: WHITE,
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 18,
}));

const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 10,
  backgroundColor: PRIMARY_LIGHT_BLUE,
  height: 42,
  maxWidth: 280,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 700,
  borderRadius: 10,
}));
const InquiryTypeForm = () => {
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
  });
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const res = await InquiryTypeService.createInquiryType(formValues);
      setFormValues({
        name: "",
      });
      alert("Inquiry type submitted successfully");
    } catch (error) {
      alert("Error creating Inquiry type");
    }
    setLoading(false);
  };
  return (
    <Stack direction="column" spacing={3}>
      <CustomTypography>Inquiry Type</CustomTypography>

      <CustomTextField
        size="small"
        onChange={(e) =>
          setFormValues({
            ...formValues,
            name: e.target.value,
          })
        }
        value={formValues.name}
        label="Name"
      />
      <Grid alignItems="center" justifyContent="center">
        <CustomButton onClick={handleSubmit}>{loading ? <CircularProgress size={15} /> : "Add Type"} </CustomButton>
      </Grid>
    </Stack>
  );
};

export default InquiryTypeForm;
